import React from 'react';
import './index.css';
import CardMajor from '../../components/kanban/card-major';

class CardDetails extends React.Component<any> {


  render() {
    return (
      <div className="container">
        <div></div>
        <div className="m-3">
          <CardMajor />
        </div>
      </div>
    );
  }
}

export default CardDetails;
